import { PanelShell, EmptyState, adminSectionsFor } from "../index";

/**
 * Admin module — renders the admin sections a signed-in user's permissions unlock, inside the
 * shared customer-facing workspace app (`@djsem/ui`'s `DJSEMWorkspaceApp`). Distinct from the
 * separate, independently-deployable `apps/admin` operator console (moderation/audit/AI-provider
 * tools), which this module predates and does not replace.
 *
 * @param permissions - The signed-in user's permission strings; determines which admin
 *   sections (if any) are visible.
 * @returns An empty-state notice when no admin sections are available, otherwise a panel
 *   listing the unlocked admin sections.
 * @see docs/state/agents/claude/prompts/143-admin-console-separate-service.md
 */
export function AdminModule({ permissions }: { permissions: string[] }) {
  const sections = adminSectionsFor(permissions);
  if (sections.length === 0) return <EmptyState title="No admin access" detail="Ask a workspace admin to grant support permissions." />;
  return (
    <PanelShell title="Admin">
      {sections.map(s => <div key={s} style={{ padding: "4px 0" }}>{s}</div>)}
    </PanelShell>
  );
}
